import { englishCourses } from './englishCourses';
import { englishSpecialistCourses } from './englishSpecialistCourses';
import { youngLearnerCourses } from './youngLearnerCourses';
import { professionalCourses } from './professionalCourses';
import { shortCourses } from './shortCourses';
import type { Course, CourseGroup } from '../../types/content';

export const courseGroups: CourseGroup[] = [
  {
    id: 'english',
    label: 'English Language Courses',
    title: 'Improve your English for life and work',
    description: 'Year-round courses for adults and students from beginner to advanced. Build everyday skills, prepare for an exam or use English at work.',
  },
  {
    id: 'young',
    label: 'Young Learner Courses',
    title: 'Safe programmes for young learners',
    description: 'Camps, mini-stays and school programmes for children and teens. Lessons, activities and care from trained group leaders.',
  },
  {
    id: 'professional',
    label: 'Professional Courses',
    title: 'Grow your teaching and career skills',
    description: 'Qualifications and practical courses for teachers and professionals, all taught in English.',
  },
  {
    id: 'short',
    label: 'Short Courses',
    title: 'Learn something new in a short time',
    description: 'Seasonal courses of a few weeks in English, Spanish, digital marketing and AI literacy.',
  },
];

export const courses: Course[] = [
  ...englishCourses,
  ...englishSpecialistCourses,
  ...youngLearnerCourses,
  ...professionalCourses,
  ...shortCourses,
];
